<template>
    <div id="app" class="container" :class="{ on : showMenu }">
        <div class="scroll">
            <header-box />
            <home />
            <keep-alive>
                <router-view />
            </keep-alive>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import HeaderBox from "@/components/HeaderBox.vue"
import Home from "@/components/Home.vue"
import Bus from '@/eventbus.js'

export default {
    name: 'App',
    data() {
        return {
            showMenu: false,
            scrollTop: 0,
            container: null,
            scroll: null,
            popCate: false,
            popBox: false
        }
    },

    methods: {
        scrollHeader() {
            const container = document.getElementById('app')
            const scroll = document.querySelector('.container>.scroll')
            const music = document.getElementById('music')
            const booth = document.getElementById('booth')
            const product = document.getElementById('product')
            const schedule = document.getElementById('schedule')
            const video = document.getElementById('video')
            container.onscroll = (e) => {

                const musicTop = music.getBoundingClientRect().top
                const boothTop = booth.getBoundingClientRect().top
                const productTop = product.getBoundingClientRect().top
                const scheduleTop = schedule.getBoundingClientRect().top
                const videoTop = video.getBoundingClientRect().top

                if (musicTop <= 0 && boothTop > 0) {
                    console.log('mmmmmm')
                    return Bus.$emit('scrollHeader', 'music')
                } else if (productTop > 5) {
                    console.log('bbbbb')
                    return Bus.$emit('scrollHeader', 'booth')
                } else if (scheduleTop > 5) {
                    console.log('pppppp')
                    return Bus.$emit('scrollHeader', 'product')
                } else if (videoTop > 5) {
                    console.log('sssss')
                    return Bus.$emit('scrollHeader', 'schedule')
                } else {
                    console.log('sssss')
                    return Bus.$emit('scrollHeader', 'video')
                }

            }
        }
    },

    created() {

    },
    mounted() {
        this.container = document.querySelector('.container')
        this.scroll = document.querySelector('.container>.scroll')
        Bus.$on('switchMenu', (menu) => {  
                if (menu) {
                this.scrollTop = this.container.scrollTop
                this.scroll.style.top = '-' + this.scrollTop + 'px'
            } else {
                setTimeout(() => {
                    this.container.scrollTop = this.scrollTop
                }, 0)
            }
            this.showMenu = menu
        })

        Bus.$on('switchCate', (menu) => {  
            if (menu && !this.popBox) {
                this.scrollTop = this.container.scrollTop
                this.scroll.style.top = '-' + this.scrollTop + 'px'
            } else {
                setTimeout(() => {
                    this.container.scrollTop = this.scrollTop
                }, 0)
            }
            this.showMenu = menu
            this.popCate = menu
        })

        Bus.$on('switchBox', (menu) => {  
            if (menu && !this.popCate) {
                this.scrollTop = this.container.scrollTop
                this.scroll.style.top = '-' + this.scrollTop + 'px'
            } else {
                setTimeout(() => {
                    this.container.scrollTop = this.scrollTop
                }, 0)
            }
            this.showMenu = menu
            this.popBox = menu
        })


        this.scrollHeader()



    },
    components: {
        HeaderBox,
        Home
    }
};
</script>

<style lang="scss">
@import "./styles/app.scss";
</style>